// Services
import { getUserId } from "app/services/LoginService";

const yardFormConfig = ({ mode } = {}) => {
	if (!mode || mode === "EDIT") {
		return {
			items: [
				{
					type: "section",
					label: "Basic Information",
					section: { classes: { label: " -mt-1 " } },
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "name",
								type: "text",
								label: "Yard Name",
								required: true,
								placeholder: "Enter yard name",
							},
							{
								key: "type",
								type: "select",
								label: "Yard Type",
								required: true,
								options: [
									{ value: "pickup", label: "Pickup" },
									{ value: "delivery", label: "Delivery" },
									{ value: "both", label: "Both" },
								],
								defaultValue: "both",
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "isHomeYard",
								type: "checkbox",
								label: "Home Yard",
								description: "Mark this yard as a home yard for the carrier",
								defaultValue: false,
							},
						],
					},
				},
				{
					type: "section",
					label: "Location Information",
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "address",
								label: "Address",
								type: "autocomplete",
								required: true,
								autocomplete: {
									provider: "trimblemaps",
									params: { componentRestrictions: { country: "us" } },
									icon: "location",
								},
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "city",
								type: "text",
								label: "City",
								required: true,
								placeholder: "Enter city",
							},
							{
								key: "state",
								type: "text",
								label: "State",
								required: true,
								placeholder: "Enter state",
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "zipCode",
								type: "text",
								label: "ZIP Code",
								placeholder: "Enter ZIP code",
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "lat",
								type: "number",
								label: "Latitude",
								required: true,
								placeholder: "Enter latitude",
								field: { decimals: 6 },
								step: 0.000001,
							},
							{
								key: "lng",
								type: "number",
								label: "Longitude",
								required: true,
								placeholder: "Enter longitude",
								field: { decimals: 6 },
								step: 0.000001,
							},
						],
					},
				},
				{
					type: "section",
					label: "Search Location (Optional)",
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "search_address",
								label: "Search Address",
								type: "autocomplete",
								autocomplete: {
									provider: "trimblemaps",
									params: { componentRestrictions: { country: "us" } },
									icon: "location",
								},
								description: "Alternative location for search purposes (if different from main address)",
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "search_city",
								type: "text",
								label: "Search City",
								placeholder: "Enter search city",
								description: "City to be used for search queries",
							},
							{
								key: "search_state",
								type: "text",
								label: "Search State",
								placeholder: "Enter search state",
								description: "State to be used for search queries",
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "search_lat",
								type: "number",
								label: "Search Latitude",
								placeholder: "Enter search latitude",
								field: { decimals: 6 },
								step: 0.000001,
								description: "Latitude for search location",
							},
							{
								key: "search_lng",
								type: "number",
								label: "Search Longitude",
								placeholder: "Enter search longitude",
								field: { decimals: 6 },
								step: 0.000001,
								description: "Longitude for search location",
							},
						],
					},
				},
				{
					type: "section",
					label: "Capacity & Coverage",
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "maxCapacity",
								type: "number",
								label: "Max Capacity",
								placeholder: "Enter maximum capacity",
								defaultValue: 50,
							},
							{
								key: "coverageRadius",
								type: "number",
								label: "Coverage Radius (miles)",
								placeholder: "Enter coverage radius",
								defaultValue: 150,
							},
						],
					},
				},
				{
					type: "section",
					label: "Additional Information",
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "timezone",
								type: "select",
								label: "Timezone",
								options: [
									{ value: "America/New_York", label: "Eastern Time" },
									{ value: "America/Chicago", label: "Central Time" },
									{ value: "America/Denver", label: "Mountain Time" },
									{ value: "America/Los_Angeles", label: "Pacific Time" },
								],
								defaultValue: "America/New_York",
							},
						],
					},
				},
				{ type: "action", action: "SUBMIT" },
			],
		};
	} else if (mode === "VIEW") {
		return {
			info: {
				items: [
					{
						key: "name",
						type: "text",
						label: "Yard Name",
					},
					{
						key: "type",
						type: "text",
						label: "Yard Type",
					},
					{
						key: "isHomeYard",
						type: "boolean",
						label: "Home Yard",
					},
					{
						key: "address",
						type: "text",
						label: "Address",
					},
					{
						key: "city",
						type: "text",
						label: "City",
					},
					{
						key: "state",
						type: "text",
						label: "State",
					},
					{
						key: "zipCode",
						type: "text",
						label: "ZIP Code",
					},
					{
						key: "lat",
						type: "number",
						label: "Latitude",
					},
					{
						key: "lng",
						type: "number",
						label: "Longitude",
					},
					{
						key: "search_city",
						type: "text",
						label: "Search City",
					},
					{
						key: "search_state",
						type: "text",
						label: "Search State",
					},
					{
						key: "search_lat",
						type: "number",
						label: "Search Latitude",
					},
					{
						key: "search_lng",
						type: "number",
						label: "Search Longitude",
					},
					{
						key: "maxCapacity",
						type: "number",
						label: "Max Capacity",
					},
					{
						key: "coverageRadius",
						type: "number",
						label: "Coverage Radius",
					},
					{
						key: "timezone",
						type: "text",
						label: "Timezone",
					},
					{
						key: "notes",
						type: "textarea",
						label: "Notes",
					},
				],
			},
		};
	}
};

const yardForm = ({ user } = {}) => {
	return {
		urlPOST: "api/profile/carriers/:carrierId/yards",
		urlGET: "api/profile/carriers/:carrierId/yards/:id",
		urlPUT: "api/profile/carriers/:carrierId/yards/:id",
		urlDELETE: "api/profile/carriers/:carrierId/yards/:id",
		idKey: "_id",
		triggerEvent: ["yardRevision", "profileRevision", "dataRevision"],
		listenEvent: "yardRevision",
		header: {
			create: { label: "Add New Yard" },
			edit: { label: "Edit Yard" },
			delete: { label: "Delete Yard" },
			view: { label: "View Yard" },
		},
		messages: {
			edit: { success: "Successfully Saved Information" },
			create: { sameAs: "edit" },
		},
		content: {
			delete: {
				items: [
					{
						type: "message",
						builder: (item) => `Would you like to permanently delete yard '${item.name}'?`,
					},
					{
						type: "group",
						content: {
							items: [
								{ type: "action", action: "CANCEL" },
								{ type: "action", action: "DELETE" },
							],
						},
					},
				],
			},
			view: {
				sameAs: "edit",
			},
			create: {
				...yardFormConfig({ mode: "EDIT" }),
			},
			edit: yardFormConfig({ mode: "EDIT" }),
		},
	};
};

export { yardForm, yardFormConfig };
